"use client"

import { createContext, useContext } from "react"

export const ThemeProviderContext = createContext({ theme: "light", setTheme: (_: string) => {} })

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }

  return context
}
